
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILoginOtpState } from './login-otp.reducer';

export const selectLoginOtpState =
  createFeatureSelector<ILoginOtpState>('loginOtp');

export const selectTelefonoOtp = createSelector(
  selectLoginOtpState,
  (state) => state.telefono ?? ''
);

export const selectEsitoOtp = createSelector(
  selectLoginOtpState,
  (state) => state.esito ?? ''
);

export const selectLoadingOtp = createSelector(
  selectLoginOtpState,
  (state) => state.loading
);

export const selectSeedOtp = createSelector(
  selectLoginOtpState,
  (state) => state.seed
);

export const selectOtpTtlSeconds = createSelector(
  selectLoginOtpState,
  (state) => state.otpTtlSeconds
);

export const selectErrorOtp = createSelector(
  selectLoginOtpState,
  (state) => state.error
);

export const selectUsernameOtp = createSelector(
  selectLoginOtpState,
  (state) => state.username
);

export const selectMsgCodeOtp = createSelector(
  selectLoginOtpState,
  (state) => state.msgCode
);

export const selectMaxTentativiOtp = createSelector(
  selectLoginOtpState,
  (state) => state.maxTentativi
);
